import { render, staticRenderFns } from "./InventoryItemInRequest.vue?vue&type=template&id=19985630&scoped=true"
import script from "./InventoryItemInRequest.vue?vue&type=script&lang=js"
export * from "./InventoryItemInRequest.vue?vue&type=script&lang=js"
import style0 from "./InventoryItemInRequest.vue?vue&type=style&index=0&id=19985630&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19985630",
  null
  
)

export default component.exports